<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_Fm02">Series Editor’s Preface</a></p>
<p class="toc"><a href="#/xhtml/09_Preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/10_Acknowledgement">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/11_Fm03">Notes on Translation</a></p>
<p class="toca"><a href="#/xhtml/12_Introduction">Introduction</a></p>
<p class="toct"><a href="#/xhtml/13_Chapter01"><span class="small">ONE</span></a></p>
<p class="toc"><a href="#/xhtml/13_Chapter01">Rhetorical Themes in Mao Zedong’s Early Writings</a></p>
<p class="toct"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample"><span class="small">TWO</span></span></p>
<p class="toc"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample">Mao Zedong’s Theories of Rhetoric</span></p>
<p class="toct"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample"><span class="small">THREE</span></span></p>
<p class="toc"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample">Mao Zedong’s Rhetorical Styles</span></p>
<p class="toct"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample"><span class="small">FOUR</span></span></p>
<p class="toc"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">Mao Zedong’s Rhetoric of Class Struggle</span></p>
<p class="toct"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample"><span class="small">FIVE</span></span></p>
<p class="toc"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">Mao Zedong’s Rhetorical Construction of a New Communist Person</span></p>
<p class="toct"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample"><span class="small">SIX</span></span></p>
<p class="toc"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">Mao Zedong’s Rhetorical Constructions of Chinese Nationalism</span></p>
<p class="toct"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample"><span class="small">SEVEN</span></span></p>
<p class="toc"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample">Rhetoric of Mao Zedong’s Foreign Policy</span></p>
<p class="toct"><span href="#/xhtml/20_Conclusion" title="Link target outside of Sample">Conclusion: Mao Zedong’s Rhetorical Legacy Lives On</span></p>
<p class="toca"><span href="#/xhtml/21_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/22_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/23_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?08016bae